/**
 * DJI México - 活动落地页埋点（template: page.promotion）
 * ------------------------------------------------------------------
 * 首个接入页面：/pages/dji-grand-opening-week（Grand Opening Week）
 *
 * ⚠️ 范围（2026-08-24 确认）：活动页不属于「首页 / 系列页 / 详情页」三个必做页面，
 *    只保留下列三个点位，商品曝光 / 商品点击 / 加购已按确认移除。
 *
 *    ① Banner 按钮      view_promotion（曝光） + select_promotion（点击）
 *    ② 转盘邮件订阅      newsletter_submit_attempt（提交尝试） + generate_lead（订阅成功）
 *    ③ 整页浏览深度      page_scroll_depth（25/50/75/100，100 档带 is_complete）
 *
 * 事件名与三个必做页面完全一致（同一业务动作不另起名），来源差异由
 * page_type / template_id / component_id / placement / campaign_id 区分。
 *
 * 明确不做：
 *   - 折扣专区的商品曝光、商品点击、加购（已出范围）；
 *   - 活动时间轴、权益卡、条款区等纯展示内容的逐卡曝光；
 *   - 加购按钮点击本身不预发事件。
 */
(function (w, d) {
  'use strict';

  var DL = w.DJIDataLayer;
  if (!DL) return;

  /* ================================================================ */
  /* 活动页登记表：新增活动页只要在这里加一段                            */
  /* ================================================================ */

  var PAGES = {
    'dji-grand-opening-week': {
      campaign_id: 'grand_opening_week',
      campaign_name: 'DJI Grand Opening Week',

      /* ① 顶部活动主视觉 + CTA（CTA 是锚点，滚到页内常驻的 inline 转盘区块） */
      hero: {
        root: '.dji-grand-opening-banner',
        component: 'hero_banner',
        component_id: 'campaign_hero',
        placement: 'campaign_hero',
        promotion_id: 'grand_opening_hero',
        cta: '.dji-grand-opening-banner__cta',
        cta_element_id: 'join_now'
      },

      /* ② 抽奖转盘邮件订阅（PopupBoost / Wheelify 应用，inline 区块常驻页内） */
      wheel: {
        form: 'form.pb-form',
        email: 'input[type="email"].pb-input',
        consent: '#pb-gdpr',
        component: 'newsletter_form',
        component_id: 'campaign_spin_wheel',
        placement: 'campaign_spin_wheel',
        /* 应用接口特征，用于判定订阅是否真的成功 */
        api: /popupboost|popup-boost|wheelify|spin[-_]?wheel/i,
        /* 成功后出现的结果 UI（中奖码 / 优惠券面板） */
        result: '.pb-result, .pb-coupon, .pb-prize, [class*="pb-"][class*="result"], [class*="pb-"][class*="coupon"]'
      },

      /* ③ 整页浏览深度 */
      scroll: {
        component: 'page_engagement',
        component_id: 'campaign_page_scroll',
        placement: 'campaign_page',
        thresholds: [25, 50, 75, 100]
      }
    }
  };

  /* ================================================================ */
  /* 配置解析：登记表优先，未登记的活动页兜底                            */
  /* ================================================================ */
  /**
   * ⚠️ 上一版是 PAGES[page_handle] 精确匹配，匹配不到直接 return。
   *    后果：运营每新建一个活动页都必须回来改这个 JS，漏改就整页哑掉 ——
   *    线上 /pages/dji-grand-opening-week 换模板后就踩过一次。
   *
   *    模块能执行到这里，说明 snippet 已按模板后缀判定本页是活动页
   *    （dji_is_promotion），所以「是不是活动页」已经有人把过关了。
   *    活动页都从同一份 custom_liquid 模板复制，DOM 结构一致，
   *    真正因页面而异的只有 campaign 标识。
   *    因此未登记时沿用同一套 DOM 钩子，campaign_id 取 page_handle 本身
   *    —— 确定性、可追溯，不去猜业务命名。
   *    需要专属 campaign_name / promotion_id 的页面，在 PAGES 里补一条即可覆盖。
   */
  function defaultConfig(handle) {
    return {
      campaign_id: handle,
      campaign_name: handle,
      hero: {
        root: '.dji-grand-opening-banner',
        component: 'hero_banner',
        component_id: 'campaign_hero',
        placement: 'campaign_hero',
        promotion_id: handle + '_hero',
        cta: '.dji-grand-opening-banner__cta',
        cta_element_id: 'join_now'
      },
      wheel: {
        form: 'form.pb-form',
        email: 'input[type="email"].pb-input',
        consent: '#pb-gdpr',
        component: 'newsletter_form',
        component_id: 'campaign_spin_wheel',
        placement: 'campaign_spin_wheel',
        api: /popupboost|popup-boost|wheelify|spin[-_]?wheel/i,
        result: '.pb-result, .pb-coupon, .pb-prize, [class*="pb-"][class*="result"], [class*="pb-"][class*="coupon"]'
      },
      scroll: {
        component: 'page_engagement',
        component_id: 'campaign_page_scroll',
        placement: 'campaign_page',
        thresholds: [25, 50, 75, 100]
      }
    };
  }

  /** 登记表条目覆盖默认配置：顶层字段浅合并，hero/wheel/scroll 逐字段合并 */
  function resolveConfig(handle) {
    if (!handle) return null;
    var base = defaultConfig(handle);
    var over = PAGES[handle];
    if (!over) return base;
    var k;
    for (k in over) {
      if (k === 'hero' || k === 'wheel' || k === 'scroll') {
        var sub = over[k] || {};
        for (var sk in sub) base[k][sk] = sub[sk];
      } else {
        base[k] = over[k];
      }
    }
    return base;
  }

  var CFG = resolveConfig(DL.ctx.page_handle);
  if (!CFG) return;

  /* ================================================================ */
  /* 工具                                                              */
  /* ================================================================ */

  function txt(el) {
    return el && el.innerText ? el.innerText.trim().replace(/\s+/g, ' ').slice(0, 80) : '';
  }

  function visible(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    var s = w.getComputedStyle(el);
    return s.display !== 'none' && s.visibility !== 'hidden' && r.width > 0 && r.height > 0;
  }

  function base(o, extra) {
    var out = {
      page_type: DL.ctx.page_type,
      component: o.component,
      component_id: o.component_id,
      placement: o.placement,
      campaign_id: CFG.campaign_id,
      campaign_name: CFG.campaign_name
    };
    for (var k in (extra || {})) out[k] = extra[k];
    return out;
  }

  /* ================================================================ */
  /* ① Banner 按钮：view_promotion / select_promotion                  */
  /* ================================================================ */

  function initHero() {
    var cfg = CFG.hero;
    var root = d.querySelector(cfg.root);
    if (!root) return;

    function promoName() {
      return txt(root.querySelector('h1, h2')) || cfg.promotion_id;
    }

    /* 曝光：可见 >=50% 且持续 >=1s，同一 page_view 只发一次 */
    DL.observe(root, { ratio: 0.5, dwell: 1000 }, function (el, meta) {
      if (!DL.once('view_promotion|' + cfg.promotion_id)) return;
      DL.push(
        'view_promotion',
        base(cfg, {
          element_id: 'promo_hero',
          promotion_id: cfg.promotion_id,
          promotion_name: promoName(),
          creative_slot: cfg.placement,
          exposure_rule: meta && meta.rule,
          exposure_ratio: meta && meta.ratio_observed
        })
      );
    });

    /* 点击：挂 document 捕获阶段，避免被页内脚本 stopPropagation */
    d.addEventListener(
      'click',
      function (evt) {
        var t = evt.target;
        if (!t || !t.closest) return;
        var cta = t.closest(cfg.cta);
        if (!cta) return;
        DL.afterTick(function () {
          /* 该 CTA 是锚点，滚到页内 inline 转盘区块，不产生页面跳转，
             因此只校验元素可用，不要求 hasNavigation */
          if (!DL.isInteractive(cta)) return;
          DL.push(
            'select_promotion',
            base(cfg, {
              element_id: cfg.cta_element_id,
              promotion_id: cfg.promotion_id,
              promotion_name: promoName(),
              creative_slot: cfg.placement,
              /* 按钮自身文案：promotion_name 记的是标题，记不到按钮文案，
                 同一位置做按钮文案 A/B 时需要它 */
              cta_label: txt(cta),
              link_url: cta.getAttribute('href') || undefined,
              opens: 'anchor_scroll'
            })
          );
        });
      },
      true
    );
  }

  /* ================================================================ */
  /* ② 转盘邮件订阅：newsletter_submit_attempt / generate_lead         */
  /* ================================================================ */

  /**
   * 转盘由第三方应用渲染，页面上是常驻 inline 区块。
   * 事件名沿用全站订阅口径的 generate_lead，不为「转盘」另造事件名；
   * 来源用 component_id=campaign_spin_wheel + subscription_source 区分。
   *
   * 成功判定（异步成功类，不在 click 时预发）：
   *   条件 A —— 应用接口返回 2xx（onRequestSuccess 匹配 api 特征）
   *   条件 B —— 页面出现中奖结果 / 优惠码面板
   *   两者任一先满足即视为订阅成功；15 秒内都没有则判为未成功，不发事件。
   */
  function initWheel() {
    var cfg = CFG.wheel;
    if (!cfg) return;

    /* ⚠️ 不能在这里判断表单是否存在就 return：
       转盘表单由应用异步渲染，start() 在 DOMContentLoaded 时执行，
       那时 form.pb-form 通常还不存在。始终用 document 级委托，
       表单何时出现都能接住。 */
    if (!d.querySelector(cfg.form)) {
      DL.log('spin wheel form 尚未渲染，改用委托监听等待应用注入');
    }

    var pending = null;

    function wheelSource(extra) {
      return base(
        { component: cfg.component, component_id: cfg.component_id, placement: cfg.placement },
        extra
      );
    }

    function marketingConsent() {
      var box = d.querySelector(cfg.consent);
      return box ? !!box.checked : null;
    }

    function emitSuccess(how) {
      if (!pending) return;
      /* 同一会话只记一次成功订阅 */
      if (!DL.onceSession('generate_lead|' + cfg.component_id)) { pending = null; return; }
      DL.push(
        'generate_lead',
        wheelSource({
          element_id: 'spin_wheel_submit',
          lead_type: 'newsletter',
          subscription_source: 'campaign_spin_wheel',
          result: 'success',
          subscribe_method: 'spin_wheel',
          success_signal: how,
          consent_marketing_optin: pending.consent,
          /* 邮箱本身绝不进 dataLayer，只标记是否填写 */
          has_email: pending.hasEmail
        })
      );
      pending = null;
    }

    /* 提交尝试：用于看「尝试 -> 成功订阅」的损失，核心 KPI 仍以成功事件为准 */
    d.addEventListener(
      'submit',
      function (evt) {
        if (!evt.target || !evt.target.matches || !evt.target.matches(cfg.form)) return;
        var emailEl = d.querySelector(cfg.email);
        pending = {
          at: Date.now(),
          consent: marketingConsent(),
          hasEmail: !!(emailEl && emailEl.value && emailEl.value.indexOf('@') > -1)
        };
        DL.push(
          'newsletter_submit_attempt',
          wheelSource({
            element_id: 'spin_wheel_submit',
            lead_type: 'newsletter',
            subscription_source: 'campaign_spin_wheel',
            subscribe_method: 'spin_wheel',
            consent_marketing_optin: pending.consent,
            has_email: pending.hasEmail
          })
        );
        /* 超时未见成功信号则放弃，避免把失败提交计成订阅 */
        w.setTimeout(function () {
          if (pending && Date.now() - pending.at >= 15000) {
            DL.log('spin wheel: 未在 15s 内观察到成功信号，不发送 generate_lead');
            pending = null;
          }
        }, 15000);
      },
      true
    );

    /* 条件 A：应用接口成功 */
    DL.onRequestSuccess(cfg.api, function () {
      if (pending) emitSuccess('api');
    });

    /* 条件 B：结果 / 优惠码面板出现。转盘容器也是异步注入的，直接观察 body 子树 */
    var mo = new MutationObserver(function () {
      if (!pending) return;
      var el = d.querySelector(cfg.result);
      if (el && visible(el)) emitSuccess('result_ui');
    });
    mo.observe(d.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class', 'style'] });
  }

  /* ================================================================ */
  /* ③ 整页浏览深度：page_scroll_depth                                 */
  /* ================================================================ */

  /**
   * 按可视底边占全文档高度的百分比计算，达到阈值时发送，每个会话每档只发一次
   * （去重键含 page_handle，换活动页会重新计）。
   * 100% 档额外带 is_complete=true，用于筛「完整浏览完活动页的 session」。
   * 同时带上到达该档所用时间，便于把秒到底的异常流量过滤掉。
   */
  function initScrollDepth() {
    var cfg = CFG.scroll;
    if (!cfg) return;
    var thresholds = (cfg.thresholds || [100]).slice().sort(function (a, b) { return a - b; });
    var startedAt = Date.now();
    var maxPct = 0;
    var ticking = false;

    function currentPct() {
      var doc = d.documentElement;
      var total = Math.max(doc.scrollHeight, d.body ? d.body.scrollHeight : 0);
      if (!total) return 0;
      var seen = (w.scrollY || w.pageYOffset || 0) + w.innerHeight;
      /* 留 2px 容差：部分浏览器底部会差零点几像素，导致永远到不了 100% */
      return Math.min(100, Math.round(((seen + 2) / total) * 100));
    }

    function check() {
      ticking = false;
      var pct = currentPct();
      if (pct <= maxPct) return;
      maxPct = pct;
      for (var i = 0; i < thresholds.length; i++) {
        var t = thresholds[i];
        if (pct < t) continue;
        if (!DL.onceSession('scroll_depth|' + DL.ctx.page_handle + '|' + t)) continue;
        DL.push(
          'page_scroll_depth',
          base(
            { component: cfg.component, component_id: cfg.component_id, placement: cfg.placement },
            {
              element_id: 'page_scroll',
              percent_scrolled: t,
              is_complete: t >= 100,
              page_handle: DL.ctx.page_handle,
              time_to_depth_ms: Date.now() - startedAt,
              page_height: Math.max(d.documentElement.scrollHeight, d.body ? d.body.scrollHeight : 0)
            }
          )
        );
      }
    }

    w.addEventListener(
      'scroll',
      function () {
        if (ticking) return;
        ticking = true;
        w.requestAnimationFrame(check);
      },
      { passive: true }
    );
    /* 短页面首屏就已经到底的情况 */
    w.setTimeout(check, 1200);
  }

  /* ================================================================ */

  function start() {
    initHero();
    initWheel();
    initScrollDepth();
    DL.log('promotion tracking ready', CFG.campaign_id, '（仅 banner / 转盘订阅 / 浏览深度）');
  }

  if (d.readyState === 'loading') {
    d.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})(window, document);
